<template>
  <div id="playlist_page" class="centered" v-if="loaded">
    <div class="head"><h1>פלייליסט | <span v-text="playlist.name"></span></h1><a @click="edit"><i class="fas fa-edit"></i></a><a @click="remove"><i class="fas fa-trash"></i></a></div>
    <h2>מספר לינקטונים: {{items.length}} - תזמון: {{total_time}}</h2>
    <div id="items_table">
      <div v-for="(item,i) in items" v-show="item.id > 0" :key="item.id">
        <ItemStrip :item="item.lt_data" :num="i+1" @play="handlePlay(item.id)" @remove="remove_song(item.id)" />
      </div>
    </div> 
  </div>
</template>
<script>

import ItemStrip from '../components/playlist_item_strip.vue';

export default {
  components: {  ItemStrip },
  data(){
    return {
      id: this.$route.params.id,
      items: [],
      playlist: {},
      total_time: 0,
      loaded: false,
      playerPlaylist: []
    }
  },
  methods: {
    edit(){

    },
    handlePlay(id) {
      const item = this.playerPlaylist.find(song => song.id === id);
      
      if (item) {
          
          const newPlayerPlaylist = [item, ...this.playerPlaylist.filter(song => song.id !== id)];
          this.$emit('playPlaylist', newPlayerPlaylist);
      }
    },
    remove(){
      if (confirm('האם למחוק את הפלייליסט?'))
      {
        this.api({ action: 'playlist/remove', data: { id: this.id } }, () => { 
          this.alert('הפלייליסט נמחק')
        });
      }
    },
    remove_song(id){
      if (confirm('האם למחוק את הפלייליסט?'))
      {
        this.api({ action: 'playlist/remove_item', data: { song_id: id, playlist: this.id } }, () => { 
          this.alert('השיר נמחק');
          
          this.init();

        });
      }
    },
    init(){
      let params = new URLSearchParams(document.location.search);
      let date = params.get("date");
      let sendData = { id: this.id  }
      if (date) sendData.date = date;
      this.api({ action: 'playlist/get_playlist_list', data: sendData }, (data) => { 
          this.items = data.data.list;
          this.playlist = data.data.playlist;
          this.total_time = data.data.total_time;

          this.playerPlaylist = [];
          for (let i in this.items)
          {
            let itemO = this.items[i];

            // app_listen is the signed url the player actually loads. These rows are
            // hand-built, and it was never copied onto them — so activeSong.app_listen
            // came out undefined, plyr got an empty source, and a playlist track sat
            // there with networkState 3 and never made a single request. The catalog
            // path passes a whole linktone, which is why only playlists were silent.
            let songs = (itemO.lt_data && itemO.lt_data.songs) ? itemO.lt_data.songs : [];
            let song = songs.filter(s => s.id == itemO.id)[0];

            this.playerPlaylist.push({
              id: itemO.id,
              pic_tumb: itemO.lt_data.pic_tumb,
              name: itemO.name,
              artist: itemO.lt_data.artist,
              app_listen: itemO.app_listen || (song ? song.app_listen : ''),
              playing_now: false
            });
          }
          this.loaded = true;
      });
    }
  },
  mounted(){ 
    this.init();
        
  }
  
}
</script>

<style scoped lang="scss">
#playlist_page{
  .head {  margin-bottom: 15px; display: flex; gap:20px; }
  h1 { font-size: 30px; 
    span  { color: #ff1854;}
  }
  h2 { font-weight: normal; opacity: 0.4; margin-bottom: 25px; font-size: 23px;}
}
</style>